import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const InfoPill = ({ left, right, className = "mx-3 mt-4", style }) => {
  return (
    <div className={className} style={style}>
      <span
        style={{
          fontSize: "0.9rem",
          fontWeight: "bold",
          padding: ".45rem .0rem .45rem .9rem",
          backgroundColor: "#293846",
          borderRadius: ".5rem",
          color: "#fff",
          display: "inline-flex",
          alignItems: "center",
          whiteSpace: "nowrap",
        }}
      >
        {left}{" "}
        <span
          style={{
            color: "#fff",
            paddingTop: ".45rem",
            paddingBottom: ".45rem",
            paddingLeft: ".9rem",
            paddingRight: ".9rem",
            fontSize: "0.9rem",
            fontWeight: "bold",
            marginLeft: ".8rem",
            backgroundColor: " #18a689",
            borderTopRightRadius: ".5rem",
            borderBottomRightRadius: ".5rem",
            whiteSpace: "nowrap",
          }}
        >
          {right}
        </span>
      </span>
    </div>
  );
};

export default InfoPill;